import BaseService from '../../../middleware/BaseService';

const GET_URL_ENDPOINT = '/userinfo';
const GET_LANGUAGE_ENDPOINT = `/user/{userId}/language`;

class UserService extends BaseService {
  prefix = GET_URL_ENDPOINT;

  async getLanguage(userId) {
    const response = await this.search({}, GET_LANGUAGE_ENDPOINT.replace('{userId}', userId));
    return response.data;
  }

  async setLanguage(userId, langId) {
    return this.post({language: langId}, GET_LANGUAGE_ENDPOINT.replace('{userId}', userId));
  }
}

export default new UserService();

